module.exports = __webpack_public_path__ + "media/components/components/booking/KidsSafety/assets/seat-belts-flyo-883e19e0a1ad706ee6614a6281ad0f3d.svg";